import { FacebookIcon, GoogleIcon, WeaveIcon } from '../../icons';
import { ReviewsTypes } from '@frontend/api-reviews';

type Props = {
  site?: ReviewsTypes.SiteName;
  size?: number;
  className?: string;
};

export const SiteLogo = ({ site = ReviewsTypes.SiteName.Private, size, className }: Props) => {
  switch (site) {
    case ReviewsTypes.SiteName.Facebook:
      return <FacebookIcon size={size} className={className} />;

    case ReviewsTypes.SiteName.Google:
      return <GoogleIcon size={size} className={className} />;

    default:
      return <WeaveIcon size={size} className={className} />;
  }
};
